
let isDom = obj => {
  if (!obj) return false
  return typeof obj === 'object' ? obj instanceof HTMLElement : false
}
/*
* options: {
*   dom: HTMLElement 需要移动的元素
*   drag: HTMLElement 可拖动元素
*   start: Function  开始拖动触发
*   moveIng: Function  拖动中触发
*   end: Function  拖动结束触发
*   maxMoveDistance: Number 元素移动到最边上所暴露的最大宽度
* }
* */
export default function move (options = {}) {
  // drag 如果没有值，则默认dom为可以拖动元素
  let drag = options.drag ? options.drag : options.dom
  if (!isDom(drag)) {
    throw new Error(`${options.drag} or ${options.dom} is not HTMLElement`)
  }
  let maxMoveDistance = options.maxMoveDistance ? options.maxMoveDistance : 40
  let startMove = e => {
    if (e.which === 1) {
      // 因为有选中内容会导致拖动有bug，所以每次点击的时候把页面选中的状态取消
      (document.selection && document.selection.empty) || (window.getSelection && window.getSelection().removeAllRanges())
      typeof options.start === 'function' && options.start(e)
      let startX = e.clientX
      let startY = e.clientY
      let left = options.dom.offsetLeft
      let top = options.dom.offsetTop
      // 最大可移动区域
      let maxTop = document.body.clientHeight
      let maxLeft = document.body.clientWidth
      // 移动的距离
      let distance = {x: 0, y: 0}
      document.onmousemove = ev => {
        // 移动的距离
        let x = ev.clientX - startX + left
        let y = ev.clientY - startY + top
        if ((x + maxMoveDistance) > maxLeft) {
          x = maxLeft - maxMoveDistance
        } else if (x < 0 && Math.abs((x - maxMoveDistance)) > options.dom.offsetWidth) {
          x = -(options.dom.offsetWidth - maxMoveDistance)
        }
        if ((y + maxMoveDistance) > maxTop) {
          y = maxTop - maxMoveDistance
        } else if (y <= 0) {
          y = 0
        }
        distance.x = x - left
        distance.y = y - top
        // 只要鼠标移动距离大于8才会开始移动元素，要不然没有必要
        if (Math.abs(distance.x) > 8 || Math.abs(distance.y) > 8) {
          options.dom.style.left = x + 'px'
          options.dom.style.top = y + 'px'
          typeof options.moveIng === 'function' && options.moveIng(x, y, distance)
        }
      }
      document.onmouseup = e => {
        typeof options.end === 'function' && options.end(e, distance)
        document.onmousemove = document.onmouseup = null
      }
    }
  }
  drag.addEventListener('mousedown', startMove, false)
  return drag
}



// WEBPACK FOOTER //
// ./src/plugins/move/index.js